module.exports = {
  buildVersion: "0.1.1",
  buildDate: 1736514251889,
}